import { QUESTION_CREATION_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { NavigateBackLink, TaskStatusTag } from '@exam-management/components';
import { PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useQuestionCreationTaskDetails } from '../../providers';
import { QuestionCreationTaskDetailsNavigationTabs } from '../question-creation-task-details-navigation-tabs';

export default function QuestionCreationTaskDetailsPageHeader() {
  const { task } = useQuestionCreationTaskDetails();

  return (
    <PageHeader
      title={task.name ?? '-'}
      linkAdornment={<NavigateBackLink to='/task-management/question-creation' replace />}
      endAdornment={
        <TaskStatusTag
          status={task.status}
          name={task.currentWorkflowStep.name}
          data-testid={QUESTION_CREATION_TASK_DATA_TEST_ID.STATUS_TAG}
        />
      }
      subtitleSection={
        <>
          <Text variant='body2'>Task ID: {task.code}</Text>
          <Text variant='body2'>Last Modified: {formatDateTime(task.updatedAt)}</Text>
        </>
      }
      tabs={<QuestionCreationTaskDetailsNavigationTabs />}
    />
  );
}
